import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import { GlobalContext } from '@thd-olt-global/global-provider-component';
import ProductPageComponent from '@thd-olt-pages/product';
import { withHeaders } from '@thd-olt-global/thd-axios/withHeaders';
import LayoutManager from '@thd-olt-component/layout-manager';
import withPageChange from '../../components/PageChange';
import { environmentKey } from '../../constants/key-provider';
import Helpers from '../../helpers/Helpers';


class ProductPage extends Component {
  static contextType = GlobalContext;

  getRecommendations = () => {
    const { request = {}, expConfiguration = {} } = this.context;
    const { channel } = request;

    const isMobile = channel === 'mobile';
    const { recsAndSearchDynamicAPIEnabled = 'false' } = expConfiguration;
    const recsAndSearchDynamicAPIEnabledBool = (recsAndSearchDynamicAPIEnabled === 'true');

    const recs = [
      'pip_alternatives',
      'visuallysimilar_1_0',
      'pip_sponsored',
      'rv_gm_pip_rr'
    ];

    if (!recsAndSearchDynamicAPIEnabledBool) {
      recs.push('PIPHorizontal2_rr');
    } else if (!isMobile && recsAndSearchDynamicAPIEnabledBool) {
      recs.push('pipsem');
    } else if (isMobile && recsAndSearchDynamicAPIEnabledBool) {
      recs.push('pip_sem_mobile');
    }

    return recs;
  }

  handleError = (apiError, sku) => {
    const { pathname } = this.props;
    if (typeof window !== 'undefined') {
      return <Redirect to={`/error${pathname}`} />;
    }
    return null;
  }

  render() {
    const {
      cookies = {},
      expConfiguration = {},
      featureSwitches = {},
      localizationStatus,
      localStore,
      request = {}
    } = this.context;

    const { BloomReachEnabled } = featureSwitches;

    const { channel, env, segment } = request;
    const apiKey = environmentKey(env);

    return (
      <LayoutManager input={{ page: 'product' }} name="Collage Product Page">
        <LayoutManager.Group name="Product Page">
          <ProductPageComponent
            {...this.props}
            apiKey={apiKey}
            bloomreach={BloomReachEnabled}
            channel={channel}
            env={env}
            localizationStatus={localizationStatus}
            localStore={localStore}
            onError={this.handleError}
            segment={segment}
            showARInstructions
            recommendations={this.getRecommendations()}
          />
        </LayoutManager.Group>
      </LayoutManager>
    );
  }
}

ProductPage.propTypes = {
  namespace: PropTypes.string.isRequired,
  replace: PropTypes.func.isRequired,
  push: PropTypes.func.isRequired,
  pathname: PropTypes.string.isRequired,
  itemId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  querystring: PropTypes.string
};

ProductPage.defaultProps = {
  querystring: null
};

const headers = [{
  name: 'x-thd-canaveral-assignment',
  contextKey: 'canaveralAssignment',
  test: /SearchNav\/v2\/pages\/search/,
  onResponse: (resp, header) => {
    if (typeof window !== 'undefined') {
      Helpers.setCookie(header.name, header.value, 30);
    }
  }
}, {
  name: 'llc-env',
  contextKey: 'llcEnv',
  test: /SearchNav\/v2\/pages\/search|productModel/,
  transformer: (value) => {
    if (/q2/.test(value)) {
      return 'q2';
    }
    return value;
  }
}, {
  name: 'tt_search',
  contextKey: 'ttSearch',
  test: /SearchNav\/v2\/pages\/search/
}];
export default withPageChange(
  withHeaders(headers)(ProductPage)
);
